import { Outlet, useRouteLoaderData } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";

import { Nav } from "@/components/Nav";
import { DialogRegistry } from "@/components/DialogRegistry";
import { ROOT_ROUTE_ID } from "@/router";
import { useStore } from "@/store";
import {
  ProductType,
  InvoiceType,
  ClientType,
  TenantType,
  DriverType,
  TransportType,
} from "@/types";
import type { User } from "@supabase/supabase-js";

interface LoaderData {
  tenant: TenantType | null;
  invoices: InvoiceType[];
  clients: ClientType[];
  products: ProductType[];
  drivers: DriverType[];
  transports: TransportType[];
  user: User | null;
}

export function App(): React.JSX.Element {
  const loaderData = useRouteLoaderData(ROOT_ROUTE_ID);
  const { setInitialData } = useStore((s) => s);

  useEffect(() => setInitialData(loaderData as LoaderData), [setInitialData, loaderData]);

  return (
    <>
      <div className="container" data-testid="app-container">
        <Nav data-testid="main-navigation" />
        <main data-testid="main-content">
          <Outlet />
        </main>
        <Toaster richColors />
        <DialogRegistry />
      </div>
    </>
  );
}
